import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { VisitsStatistic } from 'src/features/statistics/types';
import type { ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/statistics/visits/';

interface DTO {
    parkingId: string;
    subparking_ids?: string[];
    from_date?: string;
    to_date?: string;
    offset?: number;
    limit?: number;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<VisitsStatistic>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export {
    RESOURCE as LIST_VISITS_STATISTICS_RESOURCE,
    queryFn as listVisitsStatistics,
    useQueryHook as useListVisitsStatistics,
};
